export const useSuggestionsStore = defineStore('suggestions', () => {
  const api = useApi()

  const apps = ref<Suggestion[]>([])
  const businessTypes = ref<Suggestion[]>([])
  const cities = ref<Suggestion[]>([])
  const contacts = ref<Suggestion[]>([])
  const continents = ref<Suggestion[]>([])
  const counties = ref<Suggestion[]>([])
  const countries = ref<Suggestion[]>([])
  const industries = ref<Suggestion[]>([])
  const industriesMain = ref<Suggestion[]>([])
  const industriesNaics = ref<Suggestion[]>([])
  const industriesSic = ref<Suggestion[]>([])
  const jobTitles = ref<Suggestion[]>([])
  const monthlyVisitors = ref<Suggestion[]>([])
  const revenues = ref<Suggestion[]>([])
  const socialNetworks = ref<Suggestion[]>([])
  const states = ref<Suggestion[]>([])
  const stockExchanges = ref<Suggestion[]>([])
  const technologies = ref<Suggestion[]>([])
  const tlds = ref<Suggestion[]>([])
  const totalEmployees = ref<Suggestion[]>([])

  const fetchSuggestions = async (params: {
    index: ElasticIndices
    minPopulation?: number
    page?: number
    search?: string
    size?: number
  }) => {
    try {
      params.size = params.size || 50

      const { data: { suggestions } } = await api.suggestions.fetch({
        index: params.index as SuggestionsIndices,
        minPopulation: params.minPopulation,
        page: params.page,
        search: params.search,
        size: params.size,
      })

      if (params.index === 'apps') {
        apps.value = suggestions
      }
      else if (params.index === 'business-types') {
        businessTypes.value = suggestions
      }
      else if (params.index === 'cities') {
        cities.value = suggestions
      }
      else if (params.index === 'contacts') {
        contacts.value = suggestions
      }
      else if (params.index === 'continents') {
        continents.value = suggestions
      }
      else if (params.index === 'counties') {
        counties.value = suggestions
      }
      else if (params.index === 'countries') {
        countries.value = suggestions
      }
      else if (params.index === 'industries') {
        industries.value = suggestions
      }
      else if (params.index === 'industries-main') {
        industriesMain.value = suggestions
      }
      else if (params.index === 'industries-naics') {
        industriesNaics.value = suggestions
      }
      else if (params.index === 'industries-sic') {
        industriesSic.value = suggestions
      }
      else if (params.index === 'job-titles') {
        jobTitles.value = suggestions
      }
      else if (params.index === 'monthly-visitors') {
        monthlyVisitors.value = suggestions
      }
      else if (params.index === 'revenues') {
        revenues.value = suggestions
      }
      else if (params.index === 'states') {
        states.value = suggestions
      }
      else if (params.index === 'social-networks') {
        socialNetworks.value = suggestions
      }
      else if (params.index === 'stock-exchanges') {
        stockExchanges.value = suggestions
      }
      else if (params.index === 'technologies') {
        technologies.value = suggestions
      }
      else if (params.index === 'tlds') {
        tlds.value = suggestions
      }
      else if (params.index === 'total-employees') {
        totalEmployees.value = suggestions
      }

      return suggestions
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

  const updateSuggestion = async (params: {
    index: SuggestionsUpdateIndices
    suggestionCode: string
    usageCount?: boolean
  }) => {
    try {
      await api.suggestions.update(
        params.suggestionCode,
        {
          index: params.index,
          usageCount: params.usageCount || false,
        },
      )

      return {
        index: params.index,
        suggestionCode: params.suggestionCode,
      }
    }
    catch (error) {
      return Promise.reject(error)
    }
  }

  return {
    apps,
    businessTypes,
    cities,
    contacts,
    continents,
    counties,
    countries,
    fetchSuggestions,
    industries,
    industriesNaics,
    industriesSic,
    jobTitles,
    monthlyVisitors,
    revenues,
    socialNetworks,
    states,
    stockExchanges,
    technologies,
    tlds,
    totalEmployees,
    updateSuggestion,
  }
})
